import { httpClient } from '@/infra/protocols/http';
import { IUserDTO } from '@/modules/auth/dtos/user.dto';
import { IUser } from '@/modules/auth/entities/user.entity';
import { UserMapper } from '@/modules/auth/mappers/user.mapper';

export async function me(token: string): Promise<MeService.Response> {
  const response = await httpClient.get<IUserDTO>(`/v1/auth/me`, {
    safeErrorStatus: [401],
    headers: { Authorization: `Bearer ${token}` },
  });

  return UserMapper.toPresentation(response);
}

export namespace MeService {
  export type Response = IUser;
}
